import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../Homepage/Navbar';
import Footer from '../Homepage/Footer';
import { getAllClubs } from '../../actions/action';

const StudentClubs = () => {
    const [clubs, setClubs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchClubs = async () => {
            try {
                const res = await getAllClubs();
                if (res && res.success) {
                    setClubs(res.data || []);
                }
            } catch (err) {
                console.error("Error fetching clubs:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchClubs();
    }, []);

    return (
        <div className="min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-grow pt-32 pb-20 bg-dark-secondary">
                <div className="container mx-auto px-4">
                    <h1 className="text-4xl md:text-5xl font-extrabold text-center text-white mb-16">
                        Student <span className="text-nvcti-orange">Clubs</span>
                    </h1>
                    {loading ? (
                        <div className="text-center text-white text-xl">Loading clubs...</div>
                    ) : clubs.length === 0 ? (
                        <div className="text-center text-gray-400 text-xl">No clubs found.</div>
                    ) : (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                            {clubs.map((club, index) => (
                                <Link to={`/student_club/${club.club_id}`} key={club.club_id || index} className="block h-full">
                                    <div className="bg-dark-tertiary p-8 rounded-2xl shadow-xl hover:shadow-accent-primary/20 transition-all duration-300 border border-white/5 flex items-center group hover:-translate-y-1 h-full">
                                        <div className="mr-6 text-4xl text-accent-primary font-black opacity-30 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                                            {(index + 1).toString().padStart(2, '0')}
                                        </div>
                                        <h3 className="text-xl font-bold text-gray-100 group-hover:text-accent-primary transition-colors">{club.club_name}</h3>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    )}
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default StudentClubs;
